/**
 * Main hook for accessing VybeTrader client
 */

import { useContext } from 'react';
import { VybeTraderContext } from '../providers/VybeTraderClientProvider';

export const useVybeTraderClient = () => {
  const context = useContext(VybeTraderContext);
  
  if (!context) {
    throw new Error('useVybeTraderClient must be used within VybeTraderClientProvider');
  }
  
  return context;
};
